import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Tooltip from '@mui/material/Tooltip';

const useScrollStyles = makeStyles({
  arrowBox: {
    width: '20px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    cursor: 'pointer',
    flexShrink: 0,
    zIndex: 2,
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      border: '1px solid #1e3c72',
      '& svg': {
        color: '#1e3c72',
      },
    },
    '& svg': {
      width: '20px',
      height: '20px',
      color: 'rgba(0, 0, 0, 0.54)',
      transition: 'color 0.2s ease-in-out',
    },
  },
});

type ScrollArrowButtonProps = {
  direction: 'left' | 'right';
  onClick: () => void;
  tooltip?: string;
};

export const ScrollArrowButton: React.FC<ScrollArrowButtonProps> = ({
  direction,
  onClick,
  tooltip = 'More sections...',
}) => {
  const classes = useScrollStyles();
  const Icon = direction === 'left' ? ChevronLeftIcon : ChevronRightIcon;

  return (
    <Tooltip title={tooltip} placement="bottom">
      <div onClick={onClick} className={classes.arrowBox}>
        <Icon />
      </div>
    </Tooltip>
  );
}; 